import { ReactElement } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { QueryNameConsts } from "../../common/queryNameConsts";
import { getRecentFailedPayments } from "../../services/paymentTransactions/paymentTransactions.service";
import {
  PaymentTransactionsInfo,
  PaymentTransactionInfoPlaceholder,
} from "./PaymentTransactionsInfo";

const DefaultNumberFailedPayments = 8;

export const RecentPaymentFailures = (): ReactElement => {
  const { t } = useTranslation(["forms"]);

  const { data, isLoading, isError } = useQuery(
    QueryNameConsts.FailedPaymentTransactions,
    () => getRecentFailedPayments(DefaultNumberFailedPayments)
  );

  return (
    <Card>
      <Card.Body>
        <Card.Title className="heading-title-20 font-bold">
          {t("titleRejectedPaymentAttempts")}
        </Card.Title>
        {isLoading && PaymentTransactionInfoPlaceholder}
        {!isLoading && !isError && (
          <Card.Text as="div">
            {data && (
              <PaymentTransactionsInfo transactions={data} isSuccess={false} />
            )}
          </Card.Text>
        )}
      </Card.Body>
    </Card>
  );
};
export default RecentPaymentFailures;
